// extracted by mini-css-extract-plugin
module.exports = {"card":"card--Ew0Eo"};